export default __webpack_public_path__ + "static/media/8ea63ed204527d48991e930748db04d8.jpg";